import '@/publicPath';
import '@/libraries/noZoom';
import '@/libraries/polyfill';
import 'intersection-observer';
import { createLazyIcon, registerIconClassName } from '@sbo/icons-vue';
import Cookies from 'js-cookie';
import { createPinia } from 'pinia';
import { register } from 'swiper/element/bundle';
import { createApp } from 'vue';
import ObserveVisibility from 'vue3-observe-visibility';
import Sports from '@/Sports.vue';
import Api from '@/libraries/api';
import { EnumCookiesName, removeHostCookies } from '@/libraries/cookies';
import { fetchFeatureEvents } from '@/libraries/featureEvents';
import { i18nInstance } from '@/libraries/i18n';
import { setupApollo } from '@/libraries/oddsApi/apollo';
import {
    addSafariBackPageListener,
    changeLanguage,
    initApm,
    initCustomerInfo,
    logout,
    mockApi,
    ppReady,
    updateCustomerSetting,
} from '@/libraries/startup';
import { setupSurveyTool } from '@/libraries/surveyTool';
import { getHost } from '@/libraries/url';
import { router } from '@/router';
import { useAccountStore } from '@/stores/accountStore';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { isEnabled } from '@/stores/helpers/featureParsers';
import { useRootStore } from '@/stores/rootStore';

async function init() {
    const pinia = createPinia();

    await mockApi();

    if (__ENV_ASI__) {
        Cookies.set('SportsHaveSession', '1', { domain: getHost() });
    } else {
        removeHostCookies(EnumCookiesName.PromotionCode);
    }

    const [location, featureToggle, customerInfo] = await Promise.all([
        Api.getLocation(),
        Api.getConfiguration(),
        initCustomerInfo(),
    ]);

    useRootStore(pinia).setLocation(location);
    useRootStore(pinia).setIsSportsSite(true);
    const featureToggleStore = useFeatureToggleStore(pinia);
    featureToggleStore.setFeatureToggle(featureToggle);
    useAccountStore(pinia).updateCustomerInfo(customerInfo);
    useRootStore(pinia).updateSportType();

    fetchFeatureEvents();

    if (isEnabled(featureToggle.isSurveyToolEnabled)) {
        setupSurveyTool({ isAsi: __ENV_ASI__, countryCode: location.countryCode, customerInfo });
    }

    addSafariBackPageListener();

    register();

    const app = createApp(Sports);

    window.eventEmitter.on('product.updateLanguage', changeLanguage);
    window.eventEmitter.on('product.logout', logout);
    window.eventEmitter.on('product.ppReady', ppReady);
    window.eventEmitter.on('currencyUpdate', updateCustomerSetting);

    window.setInterval(() => {
        window.eventEmitter.emit('tick');
    }, 1000);

    app.use(i18nInstance);
    app.use(router);
    app.use(pinia);
    app.use(ObserveVisibility);
    app.use(createLazyIcon());
    app.use(registerIconClassName('sports'));

    if (featureToggleStore.isApmEnabled) {
        await initApm(app, router, featureToggle.oddsApiUrl, featureToggleStore.apmSampleRate, featureToggleStore.apmServerUrl);
    }

    setupApollo(app);
    app.mount('#sports');
}

init();
